import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { ExchangeModel, ExchangeMoneyEnum, ExchangeStateEnum } from '../Models/ExchangeModel';
import { GameLogic } from '../Logic/ExchangeLogic';

export class BoxController extends AnimationBaseController {
    $model: ExchangeModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('BoxController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                state: (state: ExchangeMoneyEnum) => {
                    this.gotoAndStop(state);
                },
            },
            onPointerDown: (e) => {
                if (this.$model.state === ExchangeStateEnum.open) {
                    this.$model.state = ExchangeStateEnum.close;

                } else {
                    this.$model.state = ExchangeStateEnum.open;
                }
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this.$model.state);
    }
}
